<template>
    <v-container fluid>

        <v-row>
            <v-col cols="6" >                      
                <ComponenteGrafica :options="resultado_economico.grafica_circular_capex_opex" />
            </v-col>
            <v-col cols="6" >                      
                <ComponenteGrafica :options="resultado_economico.grafica_circular_reparto_capex" />
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="6" >                      
                <ComponenteGrafica :options="resultado_economico.grafica_circular_costes_totales" />
            </v-col>
            <v-col cols="6" >  
                <!--                    
                <ComponenteGrafica :options="resultado_economico.grafica_lineas_lcoh" />
                -->
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" >                      
                <ComponenteGrafica :options="resultado_economico.grafica_lineas_icb" />
            </v-col>
        </v-row>

    </v-container>
</template>
<script>
import ComponenteGrafica from '../components/ComponenteGrafica.vue';
export default {
    
    props: {
        resultado_economico: {
        type: Object,
        required: true,
        },
    },



    data() {
        return {

            grafica_lineas: {
                xAxis: {
                    type: 'category',
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                    data: [150, 230, 224, 218, 135, 147, 260],
                    type: 'line'
                    }
                ]
                },

            grafica_circular: {
                    title: {
                        text: 'Referer of a Website',
                        subtext: 'Fake Data',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 'left'
                    },
                    series: [
                        {
                        name: 'Access From',
                        type: 'pie',
                        radius: '50%',
                        data: [
                            { value: 1048, name: 'Search Engine' },
                            { value: 735, name: 'Direct' },
                            { value: 580, name: 'Email' },
                            { value: 484, name: 'Union Ads' },
                            { value: 300, name: 'Video Ads' }
                        ],
                        emphasis: {
                            itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                        }
                    ]
                    },

        }
    },

  components: {
    ComponenteGrafica
  },
    mounted(){

      

    },

}
</script>


